module.exports = __webpack_public_path__ + "static/media/mysql.478955d1.webp";